import { Users, Heart, Laptop, PenTool, HeartHandshake, Truck, CalendarClock, PartyPopper } from "lucide-react";

const ITEMS = [
  { title: "Families visiting Dehradun", icon: Users },
  { title: "Couples seeking a quiet staycation", icon: Heart },
  { title: "Guests working remotely", icon: Laptop },
  { title: "Writers, artists and creators looking for space", icon: PenTool },
  { title: "People visiting parents, relatives or institutions in the city", icon: HeartHandshake },
  { title: "Guests between homes or relocating", icon: Truck },
  { title: "Long-stay visitors", icon: CalendarClock },
  { title: "Small private family gatherings · subject to prior approval", icon: PartyPopper },
];

export default function WhoFor() {
  return (
    <section className="py-24 md:py-32 bg-[#EFEAE4]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#985F47] mb-5">Who the house is for</div>
          <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest text-[#2C392F] font-light">
            A stay that fits <span className="italic text-[#985F47]">different kinds of pauses.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`who-for-${i}`}
                className="reveal bg-[#F7F5F0] border border-[#2C392F]/10 rounded-2xl p-7 hover:border-[#985F47]/40 transition-all min-h-[180px] flex flex-col justify-between"
              >
                <Icon className="text-[#6A7B61]" size={24} strokeWidth={1.4} />
                <h3 className="serif text-[22px] text-[#2C392F] leading-tight mt-6">{it.title}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
